<p-autoComplete
  [(ngModel)]="value"
  [suggestions]="filteredTypes"
  [dropdown]="true"
  [forceSelection]="forceSelection"
  [placeholder]="placeholder"
  (completeMethod)="onFilterSuggestions($event)"
>
</p-autoComplete>
